// src/plugins/address.js
export default {
  install(Vue) {
    Vue.prototype.$getNamaWilayah = async function (tipe, id) {
      if (!id) return null;

      try {
        let response;
        switch (tipe) {
          case 'provinsi':
            response = await this.$provinsi.show(id);
            break;
          case 'kota':
            response = await this.$kota.show(id);
            break;
          case 'kecamatan':
            response = await this.$kecamatan.show(id);
            break;
          case 'kelurahan':
            response = await this.$kelurahan.show(id);
            break;
          default:
            return null;
        }
        if (response && response.data.data && response.data.data.name) {
          return response.data.data;
        } else {
          console.warn(`Data tidak valid untuk tipe ${tipe}:`, response.data);
          return null;
        }

      } catch (err) {
        console.error(`Gagal mengambil nama wilayah: ${tipe} (${id})`, err);
        return null;
      }
    };

    Vue.prototype.$getListWilayah = async function (tipe, params = {}) {
      try {
        let response;
        switch (tipe) {
          case 'provinsi':
            response = await this.$provinsi.index();
            break;
          case 'kota':
            response = await this.$kota.index(params);
            break;
          case 'kecamatan':
            response = await this.$kecamatan.index(params);
            break;
          case 'kelurahan':
            response = await this.$kelurahan.index(params);
            break;
          default:
            console.warn(`Tipe wilayah "${tipe}" tidak dikenal`);
            return [];
        }

        if (response.data) {
          return response.data;
        } else {
          console.warn(`Response kosong untuk tipe ${tipe}`, response);
          return [];
        }
      } catch (err) {
        console.error(`Gagal mengambil list wilayah: ${tipe}`, err);
        return [];
      }
    };
  }
};


// WEBPACK FOOTER //
// ./src/plugins/address.js